export enum QueueItemStatus {
    Waiting = 0,
    MissingParams = 1,
    Processing = 2,
    Error = 3,
    Success = 4,
}
